'use client';

import type { Session } from 'next-auth';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { useCallback, useState } from 'react';

import { prefetchAuthChunks } from '../auth/prefetchAuthChunks';
import ProfileButton from '../profile/ProfileButton';
import { ThemeToggle } from '../ThemeToggle';

const AuthModal = dynamic(() => import('../forms/AuthModal'), {
  ssr: false,
  loading: () => null, // чтобы не было лишнего “мигания”
});

export function ProfileArea({
  session,
  compact = false,
}: {
  session: Session | null;
  compact?: boolean;
}) {
  const [openAuthModal, setOpenAuthModal] = useState(false);

  const openModal = useCallback(() => {
    void prefetchAuthChunks(); // если хочешь прогревать заранее
    setOpenAuthModal(true);
  }, []);

  const closeModal = useCallback(() => setOpenAuthModal(false), []);

  const prefetch = useCallback(() => {
    void prefetchAuthChunks();
  }, []);

  return (
    <div className="flex items-center gap-2">
      {/* ВАЖНО: рендерим модалку только когда реально открыта */}
      {openAuthModal && <AuthModal open={openAuthModal} onClose={closeModal} />}

      <ProfileButton session={session} onClickSignIn={openModal} onPrefetchSignIn={prefetch} />

      <ThemeToggle />

      {!compact && session?.user?.role === 'ADMIN' && (
        <Link href="/admin" className="text-white text-sm">
          Админка
        </Link>
      )}
    </div>
  );
}
